"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCaseDepositPercent = validateCaseDepositPercent;
exports.isCaseVariationOrderMilestone = isCaseVariationOrderMilestone;
exports.validateCaseMilestonePercentages = validateCaseMilestonePercentages;
exports.computeCaseBudgetAmount = computeCaseBudgetAmount;
const case_workflow_constants_js_1 = require("./case-workflow.constants.js");
const case_workflow_helpers_js_1 = require("./case-workflow.helpers.js");
const round_money_js_1 = require("../money/round-money.js");
function validateCaseDepositPercent(percent) {
    if (Number.isNaN(percent) || percent <= 0) {
        return { valid: false, message: "Deposit percentage must be greater than 0" };
    }
    if (percent > case_workflow_constants_js_1.CASE_DEPOSIT_MAX_PERCENT) {
        return { valid: false, message: `Deposit percentage cannot exceed ${case_workflow_constants_js_1.CASE_DEPOSIT_MAX_PERCENT}%` };
    }
    if (percent < case_workflow_constants_js_1.CASE_DEPOSIT_MIN_PERCENT) {
        return { valid: false, message: `Deposit percentage must be at least ${case_workflow_constants_js_1.CASE_DEPOSIT_MIN_PERCENT}%` };
    }
    return { valid: true };
}
/** Milestone-level variation order (additive budget, not part of contract % split). */
function isCaseVariationOrderMilestone(milestone) {
    return milestone?.metadata?.["isVariationOrder"] === true;
}
function validateCaseMilestonePercentages(milestones) {
    if (!milestones?.length) {
        return { valid: false, message: "At least one milestone is required" };
    }
    const deposit = milestones.find((m) => (0, case_workflow_helpers_js_1.isCaseDepositMilestone)(m));
    if (!deposit) {
        return { valid: false, message: "Deposit milestone is required" };
    }
    const depositPercent = Number(deposit.metadata?.["budgetPercent"] ?? deposit.budgetPercent ?? 0);
    const depositValidation = validateCaseDepositPercent(depositPercent);
    if (!depositValidation.valid) {
        return depositValidation;
    }
    for (const milestone of milestones) {
        if (milestone.subMilestones?.length) {
            return { valid: false, message: "Sub-milestones are not allowed in CASE workflow" };
        }
    }
    const otherMilestones = milestones.filter((m) => !(0, case_workflow_helpers_js_1.isCaseDepositMilestone)(m) && !isCaseVariationOrderMilestone(m));
    let totalOther = 0;
    for (const milestone of otherMilestones) {
        const pct = Number(milestone.metadata?.["budgetPercent"] ?? milestone.budgetPercent ?? 0);
        if (Number.isNaN(pct) || pct <= 0) {
            return { valid: false, message: `Invalid percentage for milestone ${milestone.name ?? milestone.id}` };
        }
        totalOther += pct;
    }
    const total = depositPercent + totalOther;
    if (Math.abs(total - 100) > 0.01) {
        return { valid: false, message: `Milestone percentages must sum to 100% (currently ${total.toFixed(2)}%)` };
    }
    return { valid: true };
}
function computeCaseBudgetAmount(totalBudget, percent) {
    if (!totalBudget || totalBudget <= 0)
        return 0;
    return (0, round_money_js_1.roundMoney)((totalBudget * percent) / 100);
}
